export const convertToUserTime = (utcTime: string): string => {
    const date = new Date(utcTime);
  
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
  
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  